module.exports = __webpack_public_path__ + "img/other-icon-img1.bbd83ddd.svg";